import { render, staticRenderFns } from "./BtnInserirAcao.vue?vue&type=template&id=6793056c"
import script from "./BtnInserirAcao.vue?vue&type=script&lang=js"
export * from "./BtnInserirAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports